import { useLanguageContext } from "../../../context/LanguageContext";
import PortalInvalidPageView from "../../../pages/portal/PortalInvalidPageView";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config for the visitor portal page
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePortalInvalidRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/portal/invalid")
    .setLabel(translate("eva.main.entities.visitor_portal_link"))
    .setPage(<PortalInvalidPageView />);
}

export default usePortalInvalidRouteConfig;
